// シェアURL流入（fromShareUrl）をセッション内で保持する。
// シェアページの作成ボタン押下でフラグを立て、カート投入(add_to_cart)時に読んでカート行へ記録する。

import { safeSessionStorage } from '@/utils/webStorage';

const SHARE_ORIGIN_KEY = 'shareOrigin';

/** シェアデザインからの作成開始（ボタン押下）時に流入フラグを立てる。 */
export const markShareOrigin = (): void => {
  safeSessionStorage.setItem(SHARE_ORIGIN_KEY, 'true');
};

/** シェア流入フラグが立っているか */
export const hasShareOrigin = (): boolean => {
  return safeSessionStorage.getItem(SHARE_ORIGIN_KEY) === 'true';
};

/** カート追加成功時にフラグをクリアする */
export const clearShareOrigin = (): void => {
  safeSessionStorage.removeItem(SHARE_ORIGIN_KEY);
};
